export interface FaqItem {
  q: string;
  a: string;
}

export const communityFaq: FaqItem[] = [
  {
    q: "黑料网社主要看什么内容？",
    a: "本站是一个轻松向的网络吃瓜社区，主推每日热帖、高赞神回复与加精置顶热评三类内容。你可以在首页快速刷到今日最热，也可以进热帖榜按分类慢慢逛，找到自己感兴趣的那一类。",
  },
  {
    q: "帖子里的热度和点赞是怎么来的？",
    a: "热度综合了帖子的浏览量、点赞、收藏与评论互动，每隔一段时间自动刷新一次。读数只代表社区讨论的热闹程度，不代表对内容真实性的判断。",
  },
  {
    q: "「神回复」和普通评论有什么区别？",
    a: "当一条评论被大量点赞、并被版主标记为加精时，它会进入神回复精选。神回复通常是视角刁钻、一句顶十句的短评，往往是整个帖子里最值得看的部分。",
  },
  {
    q: "我可以自己投稿发帖吗？",
    a: "可以。目前通过页脚的联系邮箱提交即可，注明分类与正文，审核通过后会发布到对应板块，点赞靠前的帖子同样有机会进入热帖榜。",
  },
  {
    q: "内容会不会涉及真人真事？",
    a: "不会。站内所有故事、昵称与评论均为社区创作或经过匿名化处理的日常分享，不针对任何真实人物与事件。若你认为某条内容存在问题，欢迎通过邮箱反馈。",
  },
  {
    q: "为什么有的帖子只有几百热度也在榜上？",
    a: "热帖榜设置了分类均衡机制。除了总榜，各分类也会保留一定名额，避免小板块的优质内容被大流量淹没。你可以用分类筛选查看。",
  },
];